<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnSaveExcel'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"
                    @btnSaveExcel="onExporting()"
                  >
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'P.O Date : '" />
                          <v-col cols="2">
                            <DxDateBox
                              :value="startDate"
                              height="30px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}"
                            />
                          </v-col>
                          <span class="pa-1 subTitle"> ~ </span>
                          <v-col cols="2">
                            <DxDateBox
                              :value="endDate"
                              height="30px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {reqDtFrom = e.value && getEndFormat(e.value)}"
                            />
                          </v-col>
                          <i-label :label="'POR No : '" class="pl-2"/>
                          <v-col cols="2">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              maxLength="30"
                              v-model="porNo"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="12" align="right" class="pr-2 vat">( Included V.A.T )</v-col>
                  </v-row>
                  <DxDataGrid id="departmentInformation" 
                    class="listBox" 
                    :ref="epms4000Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @exporting="onExporting"
                    @cellPrepared="cellPrepared"
                  >
                    <DxExport :enabled="true" />
                    <!-- <DxEditing :use-icons="true" /> -->
                    <DxColumn data-field="poDte" caption="PO Date" width="8%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="poNo" caption="PO No" width="12%" data-type="string" alignment="center" cell-template="poNoTemplate" :allow-editing="false" />
                      <template #poNoTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="poDetail(data)" >
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxColumn data-field="quotNo" caption="Quotation No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="quotTitle" caption="Item" width="20%" data-type="string" alignment="left" cell-template="quotTitleTemplate" :allow-editing="false" />
                      <template #quotTitleTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="poDetail(data)" >
                          {{data.text}}
                        </v-btn>
                      </template>                  
                    <DxColumn data-field="buyerNm" caption="Purchase Charger" width="15%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="poQty" caption="PO Qty" width="5%" data-type="number" alignment="right" format='#,###' :allow-editing="false" />
                    <DxColumn data-field="poAmt" caption="PO Amount" width="8%" data-type="number" alignment="right" format='#,###' :allow-editing="false" />
                    <DxColumn data-field="moneUnit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="whQty" caption="Deli. Qty" width="5%" data-type="number" alignment="right" format='#,###' :allow-editing="false" />
                    <DxColumn data-field="transFee" caption="Trans Fee" width="5%" data-type="string" alignment="right" :allow-editing="false" />
                    <DxColumn data-field="govFee" caption="Gov.Fee" width="5%" data-type="string" alignment="right" :allow-editing="false" />
                    <DxColumn data-field="receiveYn" caption="Receipt" width="7%" alignment="center" cell-template="receiptTemplate" :allow-editing="false" />
                      <template #receiptTemplate="{ data : cellInfo }">
                        <div>
                          <div :style="cellInfo.value == 'N' && cellInfo.data.quotNo ? '' : 'display: none;'">                          
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="receipt(cellInfo)" >
                              <v-icon small class="mt-n1">
                                mdi-arrow-right-box
                              </v-icon>
                              Receipt
                            </v-btn>
                          </div>
                          <div :style="cellInfo.value == 'N' ? 'display: none;' : ''">
                            <v-icon small class="mt-n1" color="blue">
                              mdi-checkbox-marked-circle
                            </v-icon>
                          </div>
                        </div>
                      </template>
                    <DxColumn caption="PO Sheet" width="7%" type="buttons" :allow-editing="false" cell-template="poSheetTemplate" />
                      <template #poSheetTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="poSheet(data)" >
                          <v-icon small class="mt-n1">
                            mdi-arrow-right-box
                          </v-icon>
                          Print
                        </v-btn>
                      </template>
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getCurrentDate, getPreMonth , getFirstDay} from '@/utils/common.js'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getPoList , getPoReceive } from '@/api/view/hip/4/epms4000.js'
import { reportView } from '@/api/view/hip/common/common.js'

export default {
  name: 'epms4000',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxButton,
    DxExport,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      startDate: '',
      endDate: '',

      epms4000Ref: 'epms4000Ref',
      gridMainList: [{a: '2022/12/05', id: 1 , test: "N"}],

      porNo: '',
      stDte: '',
      edDte: '',
      showReceive : true,

      //cell merge
      mergeElements: [],
      mergeStartElements: [],
      poMoneUnit : ''
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms4000Ref)
    },
     showPoAmountUsd() {
      return String(this.$store.state.user.makerCd) === '96002' && this.poMoneUnit !== 'USD'
    },
  },
  mounted(){
    if(this.$route.params.stDte){
      this.stDte = this.$route.params.stDte
      this.edDte = this.$route.params.edDte
      this.porNo = this.$route.params.porNo
      this.startDate =this.$route.params.stDte
      this.endDate = this.$route.params.edDte
      this.btnRetrieve()
    } else {
      var date = new Date();
      this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
      this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
    this.doSearchMain()
  },
  methods: {
    getStrFormat(date) {
      this.stDte = getDateFormat(date)
      return getDateFormat(date)
    },
    getEndFormat(date) {
      this.edDte = getDateFormat(date)
      return getDateFormat(date)
    },
    btnReceipVis(e) {
      console.log(e)
      return true
    },
    btnRetrieve(){
      if(this.porNo === null){
        this.porNo = ''
      }
      this.doSearchMain()
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        porNo: this.porNo,
        stDte: this.stDte,
        edDte: this.edDte
      }
      await getPoList(params).then(res => {
        res.list.forEach(e => {
          e.id = e.rnum
        });
        this.gridMainList = res.list
      }).finally(() => {
        this.endLoading()
      })

    },
    cellPrepared(e){
      if (e.rowType === 'data') {
            
        e.cellElement.style.padding = '1px'
        this.merge('poDte', this.mergeElements, this.mergeStartElements, e)
      }
    },
    merge(filed, mergeEle, mergeEleStart, e){
      if (e.column.dataField === filed) {
        e.cellElement.style['vertical-align'] = 'middle'
        if (this.curRowIndex + 1 !== this.gridMainList.length) {
          if (e.rowIndex > 0) {
            // If the value of the previous row and the current value match, and the value of no is also the same
            if (e.component.cellValue(e.rowIndex - 1, e.column.dataField) == e.value && e.column.dataField === filed ) {
              if (e.component.cellValue(e.rowIndex - 1, e.column.dataField)) {
                // when value is not blank
                var prev = mergeEle[e.rowIndex - 1]
                if (!mergeEle[e.rowIndex]) {
                  mergeEle[e.rowIndex] = {}
                }
                mergeEle[e.rowIndex] = prev
                mergeEleStart[e.rowIndex] = prev
                if (prev) {
                  let curCellElement = e.cellElement
                  curCellElement.style.display = 'none'

                  var span = prev.getAttribute('rowspan')
                  if (span) {
                    prev.setAttribute('rowspan', Number(span) + 1)
                  } else {
                    prev.setAttribute('rowspan', 2)
                  }
                  this.nonDispalyedRowIndex.push(e.rowIndex)
                }
              } else {
                // when value is blank
                if (!mergeEle[e.rowIndex]) mergeEle[e.rowIndex] = {}
                mergeEle[e.rowIndex] = e.cellElement
              }
            } else {
              // If the value of the previous row is different from the current value
              if (!mergeEle[e.rowIndex]) mergeEle[e.rowIndex] = {}
              mergeEle[e.rowIndex] = e.cellElement
            }
          } else {
            // When index is 0
            if (!mergeEle[e.rowIndex]) {
              mergeEle[e.rowIndex] = {}
            }
            mergeEle[e.rowIndex] = e.cellElement
          }
          this.curRowIndex = e.rowIndex
        } else {
          // When everything is running and clicked
          if (this.nonDispalyedRowIndex.indexOf(e.rowIndex) !== -1) {
            e.cellElement.style.display = 'none'
          } else {
            if (typeof mergeEleStart[e.rowIndex + 1] === 'undefined') return
            let rowspan = mergeEleStart[e.rowIndex + 1].getAttribute('rowspan')
            e.cellElement.setAttribute('rowspan', rowspan)
          }
        }
        // To remove duplication of nonDispalyedRowIndex
        const set = new Set(this.nonDispalyedRowIndex)
        this.nonDispalyedRowIndex = [...set]
      }
    },
    poDetail(e){
      this.$router.push({name: 'epms4010' , params:{poNo: e.values[1] , stDte: this.stDte , edDte: this.edDte , porNo: this.porNo}});
    },
    receipt(e){
      let params = {
        quotNo: e.values[2],
        makerCd: this.$store.state.user.makerCd,
        userId: this.$store.state.user.userId
      }
      this.vToastifyPrompt(
        this.$t('Do you want to Receipt the Purchase Order?'),
        'info',
          current => {
            this.openLoading('searching')
            getPoReceive(params)
              .then(res => {
                if(res.list[0].ret == 'Y'){
                  notify(this.$t('Receipt PO is completed.'), 'success', 3000)
                  this.doSearchMain()
                } else {
                  this.vToastify(this.$t('An error has occured while updating receive information.'), 'warn')
                }
              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.endLoading()
              })
          },
          null,
          true
        )
    },
    poSheet(e){
      this.poMoneUnit = e.data.moneUnit
      const param = {
        fileName: this.showPoAmountUsd ? 'epms4010_96002.jrxml' : 'epms4010.jrxml',
        as_po_no: e.values[1],
        as_maker_cd: this.$store.state.user.makerCd
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Purchase Order List');

      exportDataGrid({
        component: this.gridMainInstance,
        worksheet,
        topLeftCell: { row: 1, column: 1 },
      }).then((cellRange) => {
        const headerRow = worksheet.getRow(1);
        const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
        const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
        let headerRowLength = headerRow._cells.length
        for(let i = 1; i <= headerRowLength; i++){
          headerRow.getCell(i).fill = headerStyle
          headerRow.getCell(i).border = headerBorderStyle
          headerRow.getCell(i).alignment = { horizontal: 'center' }
        }
        for(let j = 2; j <= worksheet._rows.length; j++){
          for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
            worksheet.getRow(j).getCell(a).border = headerBorderStyle
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PurchaseOrderList.xlsx');
        });
      });
      this.gridMainInstance.cancel = true;
    },
  }
}
</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
  }
  .receiptBtn:hover {
    color: #4980BC;
  }
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>